import { useQuery } from '@tanstack/react-query';
import { IMMIGRATION_DOC_DETAILS_ID_KEY } from '../../utils/constants/queryKeys';
import { getImmigrationDocDetailsById } from '../services/fn-api/ImmigrationDocuments';

export const useGetImmigrationDocDetailsById = (immigrationDocId: number | undefined) => {
  return useQuery({
    queryKey: [IMMIGRATION_DOC_DETAILS_ID_KEY, immigrationDocId],
    queryFn: () => getImmigrationDocDetailsById(immigrationDocId),
    enabled: !!immigrationDocId,
  });
};
